import Vue from 'vue';
import { keyBy } from 'lodash';
import types from './mutation-types';

const mutations = {

  [types.SET_CORE_CONCEPTS](state, coreConceptList) {
    Vue.set(state, 'coreConcepts', {
      ...state.coreConcepts,
      ...keyBy(coreConceptList, coreConcept => coreConcept.id),
    });
  },

  [types.SET_DOMAINS](state, domainList) {
    Vue.set(state, 'domains', {
      ...state.domains,
      ...keyBy(domainList, domain => domain.id),
    });
  },

  [types.SET_UNITS](state, unitList) {
    Vue.set(state, 'units', {
      ...state.units,
      ...keyBy(unitList, unit => unit.id),
    });
  },

  [types.SET_SUBJECTS](state, subjectList) {
    Vue.set(state, 'subjectMap', {
      ...state.subjectMap,
      ...keyBy(subjectList, 'id'),
    });
  },

  [types.SET_GRADES](state, gradeList) {
    Vue.set(state, 'gradeMap', {
      ...state.gradeMap,
      ...keyBy(gradeList, 'id'),
    });
  },

  [types.SET_SUBJECT_GRADES](state, subjectGrades) {
    Vue.set(state, 'subjectGrades', subjectGrades);
  },
};

export default mutations;
